import { render, staticRenderFns } from "./facet-group.vue?vue&type=template&id=21ac43bc&"
import script from "./facet-group.vue?vue&type=script&lang=js&"
export * from "./facet-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports